<script setup lang="ts">
import type { Color } from '~/types/daily-indicator.type'
import LastChange from '@/components/portals/DailyIndicator/LastChange.vue'
import { format } from 'date-fns'

defineProps<{
  seriesName: string
  todayValue: string
  latestValue: {
    value: number
    unit: string
  }
  latestColor: Color
}>()

const now = format(new Date(), 'dd/MM/yyyy')
</script>

<template>
  <div class="flex flex-col justify-center gap-y-2">
    <div
      class="text-xxs -order-1 md:order-none font-bold md:font-semibold md:text-sm xl:text-lg"
    >
      {{ seriesName }}
    </div>
    <div
      class="font-semibold md:font-bold text-xxs md:text-xl xl:text-h3 flex sm:flex-row flex-wrap flex-col items-baseline gap-x-1"
    >
      <span>{{ todayValue }}</span>
      <span class="text-xxs font-normal md:text-xs md:font-semibold">
        as at {{ now }}
      </span>
    </div>
    <LastChange
      :latest-color="latestColor"
      :latest-value="latestValue"
      label="Daily change"
    />
  </div>
</template>
